import {
    NEW_AUTHORIZATION_SET_TYPE,
    NEW_AUTHORIZATION_SET_SPONSOR,
    NEW_AUTHORIZATION_ERROR,
    NEW_AUTHORIZATION_SET_SPONSOR_FORM,
    SET_SPONSOR_SEARCH_METHOD,
    SET_INPUTS_SPONSOR_SEARCH_VALUES,
    AUTHORIZATIONS_ERROR,
    AUTHORIZATIONS_SUCCESS,
    AUTHORIZATONS_LOADING,
    BENEFICIARIES_SUCCESS,
    SET_BENEFICIARY_SELECTED,
    SET_BENEFICIARY_SELECTION,
    COMPLETE_TYPE_STEP,
    COMPLETE_SPONSOR_STEP,
    COMPLETE_METHOD_STEP,
    COMPLETE_BENEFICIARY_STEP,
    COMPLETE_BENEFICIARY_SEARCH,
    SET_BENEFICIARY,
    FIND_BENEFIRIARY_ERROR,
    SET_OUTPATIENT_CARE_FORM,
    SET_BIOMETRIC_VERIFICATION_RESULT,
    SET_LOADING_VERIFICATION,
    SET_CREATE_CLAIM_ERROR,
    SET_LOADING_CREATE_CLAIM,
    SET_NAVBAR_TYPE,
    CLEAR_NEW_AUTHORIZATION,
    SET_CREATE_CLAIM_RESULT
  } from '../mutation-types';

export default {

    [CLEAR_NEW_AUTHORIZATION]: (state) => {
        state.newAuthorization = {
            type: {},
            error: {},
            sponsorForm: [],
            beneficiarySearch: {
              sponsorSlug: null,
              formSlug: null,
              inputs: []
            },
            steps: {
              type: false,
              sponsor: false,
              method: false,
              beneficiary: false,
              beneficiarySearchComplete: false
            },
            navBarType: '',
        }
        state.beneficiaries = [],
        state.beneficiarySelected = {},
        state.outpatientCareForm = {
            beneficiaryFields: {},
            doctorFields: {},
            isVerified: null
        }
    },

    [SET_NAVBAR_TYPE]: (state, payload) => {
        state.newAuthorization.navBarType = payload
    },

    [COMPLETE_BENEFICIARY_SEARCH]: (state, payload) => {
        state.newAuthorization.steps.beneficiarySearchComplete = payload
    },

    [COMPLETE_TYPE_STEP]: (state, payload) => {
        state.newAuthorization.steps.type = payload
    },

    [COMPLETE_SPONSOR_STEP]: (state, payload) => {
        state.newAuthorization.steps.sponsor = payload
    },

    [COMPLETE_METHOD_STEP]: (state, payload) => {
        state.newAuthorization.steps.method = payload
    },

    [COMPLETE_BENEFICIARY_STEP]: (state, payload) => {
        state.newAuthorization.steps.beneficiary = payload
    },

    [NEW_AUTHORIZATION_SET_TYPE]: (state, payload) => {
        state.newAuthorization.type = payload
    },

    [NEW_AUTHORIZATION_SET_SPONSOR]: (state, payload) => {
        state.newAuthorization.beneficiarySearch.sponsorSlug = payload
    },

    [NEW_AUTHORIZATION_ERROR]: (state, payload) => {
        state.newAuthorization.error = payload
    },

    [NEW_AUTHORIZATION_SET_SPONSOR_FORM]: (state, payload) => {
        state.newAuthorization.sponsorForm = payload
    },

    [SET_SPONSOR_SEARCH_METHOD]: (state, payload) => {
        state.newAuthorization.beneficiarySearch.formSlug = payload
    },

    [SET_INPUTS_SPONSOR_SEARCH_VALUES]: (state, payload) => {
        state.newAuthorization.beneficiarySearch.inputs = payload
    },

    [BENEFICIARIES_SUCCESS]: (state, payload) => {
        state.beneficiaries = payload
    },

    [SET_BENEFICIARY_SELECTED]: (state, payload) => {
        state.beneficiarySelected = payload
    },

    [SET_BENEFICIARY_SELECTION]: (state, payload) => {
        state.isBeneficiarySelected= payload
    },

    [AUTHORIZATIONS_SUCCESS]: (state, payload) => {
        state.authorizations = payload.content
        state.links = payload.links
        state.page = payload.page
    },

    [AUTHORIZATIONS_ERROR]: (state, payload) => {
        state.errorAlert = payload
    },
    
    [AUTHORIZATONS_LOADING]: (state, payload) => {
        state.loadingAuthorizations = payload
    },

    [SET_BENEFICIARY]: (state, payload) => {
        state.beneficiary = payload
    },

    [FIND_BENEFIRIARY_ERROR]: (state, payload) => {
        state.beneficiaryError = payload
    },

    [SET_OUTPATIENT_CARE_FORM] (state, payload) {
        state.outpatientCareForm = payload
    },

    [SET_BIOMETRIC_VERIFICATION_RESULT](state, payload) {
        state.biometricVerificationResult = payload
        state.outpatientCareForm.isVerified = payload ? payload.verificationStatus === 'VERIFICATION_SUCCESS' : null
    },

    [SET_LOADING_VERIFICATION](state, isLoading) {
        state.loadingVerification = isLoading
    },

    [SET_CREATE_CLAIM_ERROR](state, errorObject) {
        state.createClaimError = errorObject
    },

    [SET_LOADING_CREATE_CLAIM](state, isLoading) {
        state.loadingCreateClaim = isLoading
    },

    [SET_CREATE_CLAIM_RESULT](state, payload) {
        state.authorizationResult = payload
    }

}
